<div class="estimates-content-div">
  <div class="estimates-timeline">
    <p class="no-results" *ngIf="!bonusList?.length">No bonus found</p>

    <div class="invoice-container left" *ngFor="let bonus of bonusList; let y=index;">
      <ion-list class="invoice-list">
        <ion-item-sliding>
          <ion-item class="model slide-item" [class.active]="bonus.status == 'Pagato'">
            <div class="invoice-content" (click)="openBonus(bonus.id)">
              <ion-row>
                <ion-col size="9">
                  <ion-row style="white-space: nowrap;">
                    <div class="id">{{ bonus.status }}</div>
                  </ion-row>    
                  <div class="name">{{ bonus.payDate | date : 'd MMM y' }}</div>                      
                </ion-col>
                <ion-col size="3">
                  <div class="amount">{{ bonus.total | currency:'EUR' }}
                  </div>
                </ion-col>
              </ion-row>
            </div>
          </ion-item>
          <ion-item-options side="end">
            <ion-item-option color="success" (click)="editBonus(bonus.id)">Edit</ion-item-option>
            <ion-item-option color="danger" (click)="deleteBonus(bonus.id)">Delete</ion-item-option>
          </ion-item-options>
        </ion-item-sliding>
      </ion-list>
    </div>
  </div>
</div>
